import { AuthState } from '@okta/okta-auth-js';

import { CommodityGroupsSummaries } from '../../services/backend/CommodityGroupsSummaries';
import { useBaseApiClient } from '../useBaseApiClient';

export const useCommodityGroupsSummaries: () => CommodityGroupsSummaries<AuthState> = () => {
  return useBaseApiClient(CommodityGroupsSummaries);
};
